// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1Ee_v","dragIcon":"SortableItem_dragIcon__3Iuup","disabled":"SortableItem_disabled__3U7-n"};